/* eslint-disable no-extra-boolean-cast */
import { toastError, toastSuccess } from '../utils/toastMessage';
import API from '../utils/API';
import * as constants from '../constants/constants';
import { getDishesSuccess } from './dishes';

const searchDishSuccess = (data, rendering) => {
  return {
    type: 'SEARCH_DISH_SUCCESS',
    data,
    rendering,
  };
};

export const saveSearchParam = (searchParam) => {
  return {
    type: 'SEARCH_VALUE',
    searchParam,
  };
};

export const saveFilterParam = (filterParam) => {
  return {
    type: 'FILTER_VALUE',
    filterParam,
  };
};

export const saveSortParam = (sortParam, order) => {
  return {
    type: 'SORT_VALUE',
    sortParam,
    order,
  };
};

export const clearSearchParams = () => {
  return {
    type: 'CLEAR_SEARCH_PARAMS',
  };
};

export const toggleLoadDishes = () => {
  return {
    type: constants.TOGGLE_LOAD_DISHES,
  };
};

export function setProducts(products) {
  return {
    type: constants.SET_PRODUCTS,
    payload: {
      products,
    },
  };
}

export function setMeasures(measures) {
  return {
    type: constants.SET_MEASURES,
    payload: {
      measures,
    },
  };
}
export const transformDishesWithTags = (dishes, tagsForExclusion) => {
  const newFilter = [];
  if (!tagsForExclusion.length) return dishes;
  dishes.forEach((dish) => {
    let productMustBeExcluded = false;
    tagsForExclusion.forEach((exclusionTags) => {
      dish.tags.forEach((tag) => {
        if (tag.tag_id === exclusionTags) {
          productMustBeExcluded = true;
        }
      });
    });
    if (!productMustBeExcluded) {
      newFilter.push(dish);
    }
  });
  return newFilter;
};

export const filterDish = (
  searchValue = '',
  tags = [],
  sortParam = 'id',
  order = 'desc',
  page = 1,
  rendering = true,
) => {
  const includeTags = tags.join('|');
  const url = `/dishes?search=${searchValue}&include_tags=${includeTags}&orderBy=${order}&column=${sortParam}&page=${page}`;
  return (dispatch, getState) => {
    dispatch(toggleLoadDishes());
    const { templateTagsFilters } = getState().templateGenerator;
    const { category } = getState().setParams;
    API.get(url)
      .then((response) => {
        toastSuccess();
        dispatch(toggleLoadDishes());
        let transformDishes = response.data.data.items.dishes.data;
        if (templateTagsFilters.length) {
          transformDishes = transformDishesWithTags(
            response.data.data.items.dishes.data,
            templateTagsFilters,
          );
        } else if (category.length) {
          transformDishes = transformDishesWithTags(response.data.data.items.dishes.data, category);
        }
        dispatch(getDishesSuccess(transformDishes));
        dispatch(setMeasures(response.data.data.items.measures));
        dispatch(searchDishSuccess(response.data.data, rendering));
      })
      .catch(() => {
        toastError();
      });
  };
};

export function getProducts(productName = '') {
  return (dispatch) => {
    API.get(`/product/find?name=${productName}`)
      .then((resp) => {
        dispatch(setProducts(resp.data.data.items.products));
        dispatch(setMeasures(resp.data.data.items.measures));
      })
      .catch(() => {
        toastError('Products list error');
      });
  };
}

export const searchDish = (value, rendering) => {
  return (dispatch) => {
    API.get(`/dishes?search=${value}`)
      .then((response) => {
        toastSuccess();
        dispatch(searchDishSuccess(response.data.data, rendering));
      })
      .catch(() => {
        toastError();
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/dishSearch.js